<template>
	<div>
		<template v-if="user && user.role_id == 10">
			<h1 class="page-header"><i class="fas fa-calendar-plus"></i> Foglalás</h1>
			<hr>
		</template>
		<div class="nav-wizards-container" ref="wizard_slider">
			<nav class="nav nav-wizards-2 mb-3">
				<div class="nav-item col" v-for="(wizard_step,id) in wizard_steps" :key="id">
					<a class="nav-link" :class="{'completed': wizard_step.id < active_wizard_step, 'active': wizard_step.id == active_wizard_step, 'disabled': wizard_step.id > active_wizard_step}" href="#">
						<div class="nav-text">{{wizard_step.name}}</div>
					</a>
				</div>
			</nav>
		</div>
		<div class="card">
			<div class="card-body">
				<component v-for="(wizard_step,id) in wizard_steps" :key="id" v-show="active_wizard_step == wizard_step.id" :is="'Step'+wizard_step.id" @validated="activeStepComplete" :ref="'wizardStepComponent'+wizard_step.id" @restart="restartBooking" @coupon-validated="couponSet" @coupon-deleted="couponUnset" @nonRefundable="setNonRefundable"></component>
			</div>
			<div class="card-footer" v-if="active_wizard_step != 5">
				<div class="row">
					<div class="col text-start">
						<button v-if="active_wizard_step != 1" class="btn btn-success rounded-pill" :disabled="sending" @click="stepBack">Vissza</button>
					</div>
					<div class="col text-end">
						<button class="btn btn-primary rounded-pill" @click="stepForwardHandler" :disabled="sending"><i class="fa fa-spin fa-cog" v-if="sending"></i>{{active_wizard_step == 4 ? 'Foglalás' : 'Következő'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Step1 from "../../components/wizard-steps/Step1";
import Step2 from "../../components/wizard-steps/Step2";
import Step3 from "../../components/wizard-steps/Step3";
import Step4 from "../../components/wizard-steps/Step4";
import Step5 from "../../components/wizard-steps/Step5";
import Booking from '../../apis/Booking';
export default {
	name:"Booking",
	components:{ Step1, Step2, Step3, Step4, Step5},
	data() {
		return {
			wizard_steps:[
				{ id:1, name:'Vendégház választás' },
				{ id:2, name:'Szobák kiválasztása' },
				{ id:3, name:'Kisérők adatai' },
				{ id:4, name:'Foglalás megerősítése' },
				{ id:5, name:'Foglalás vége' },
			],
			active_wizard_step:1,
			booking:{},
			sending: false,
		}
	},
	computed:{
		user(){
			return this.$store.state.user;
		},
	},
	watch:{
		user(val){
			if(val.role_id == 10){
				this.$set(this.booking,'user_id',val.id);
			}
		},
		active_wizard_step(val){
			if(val == 2){
				this.$refs['wizardStepComponent2'][0].getRooms();
			}
			if (val == 4) {
				this.$refs['wizardStepComponent4'][0].queryAvailableCoupons(); // Call the method on Step 4
			}
			if(val == 5){
				this.$emit('finished');
			}
		}
	},
	mounted(){
		this.restartBooking();
	},
	methods: {
		couponSet(coupon_code){
			this.$set(this.booking,'coupon',coupon_code);
		},
		setNonRefundable(value){
			this.$set(this.booking,'non_refundable',value);
		},
		couponUnset(){
			delete this.booking.coupon
		},
		restartBooking(){
			this.booking = {
				user_id:(this.user && this.user.role_id == 10) ? this.user.id : null
			};
			this.$refs['wizardStepComponent1'][0].restart();
			this.$refs['wizardStepComponent3'][0].restart();
			this.$refs['wizardStepComponent4'][0].restart();
			this.$store.commit('updateSelectedGuesthouse',null);
			this.$store.commit('updateSelectedRooms',null);
			this.$store.commit('updateFilledRooms',null);
			this.$store.commit('updateArriveAt',null);
			this.$store.commit('updateLeaveAt',null);
			this.$store.commit('updateWizardUser',null);
			this.active_wizard_step = 1;
			this.$refs.wizard_slider.scrollLeft -= 2000;
		},
		stepForward(){
			this.$refs['wizardStepComponent'+this.active_wizard_step][0].submitForm();
		},
		stepForwardHandler(){
			if(this.active_wizard_step == 4){
				this.sending = true;
				Booking.store(this.booking)
				.then(() => {
					this.stepForward();
				}).finally(() => {
					this.sending = false;
				})
			}else{
				this.stepForward();
			}
		},
		stepBack(){
			this.active_wizard_step--;
			this.$refs.wizard_slider.scrollLeft -= 200;
		},
		activeStepComplete(emitted_model){
			this.booking = { ...this.booking, ...JSON.parse(JSON.stringify(emitted_model)) };
			this.active_wizard_step++;
			this.$refs.wizard_slider.scrollLeft += 200;
		}
	}
};
</script>